<div class="ps-page">
  <div class="ps-tabs">
    <button
      type="button"
      class="ps-tab"
      [class.ps-tab--active]="activePageTab === 'assets'"
      (click)="activePageTab = 'assets'"
    >
      Asset Management
    </button>
    <button
      type="button"
      class="ps-tab"
      [class.ps-tab--active]="activePageTab === 'connections'"
      (click)="activePageTab = 'connections'"
    >
      Connections
    </button>
  </div>

  <div class="ps-content">
    <app-manage-applications
      *ngIf="activePageTab === 'assets'"
      [dataStore]="dataStore"
      (manageAsset)="activePageTab = 'connections'"
    ></app-manage-applications>
    <app-connection
      *ngIf="activePageTab === 'connections'"
      [dataStore]="dataStore"
    ></app-connection>
  </div>
</div>
